import React, { useCallback, useEffect, useState } from "react";
import "./patternPairAssociation.scss";
import TestFooter from "../testFooter/testFooter";
import { HelperContext } from "../../store/helperStore";
import { AnswerContext } from "../../store/answerStore";
import useTimer from "../../Hooks/useTimer";
import { answeredQues } from "../../helper/testHelper";
import { totalTimeOrScore } from "../../helper/scoreCounter";
import { getStudentData } from "../../helper/localStorage";
import { addTestResult } from "../../api/addTestResult";
import { LaunchTestContext } from "../../store/launchTestStore";

const grade_id = JSON.parse(localStorage.getItem("gradeId"));
const { login_id } = getStudentData();

const picturesArray2 = [
  "q1_option1_2",
  "q1_option2_2",
  "q1_option3_2",
  "q1_option4_2",
  "q1_option5_2",
].sort(() => Math.random() - 0.5);

const PatternPairAssociation = ({ question, questions, index }) => {
  const { answerC, dispatchAnswer } = AnswerContext();
  const { helperC, dispatchHelper } = HelperContext();
  const { launchTestC } = LaunchTestContext();
  const { launchTestData } = launchTestC;
  const { picturesArray } = launchTestData;

  const [userInput, setUserInput] = useState();
  const [imageIndex, setImageIndex] = useState(-1);
  const [showingImage, setShowingImage] = useState(true);
  const [hasFinished, setHasFinished] = useState(false);
  const { reset, start, time } = useTimer();

  const { isNextQues, showingNumbers } = helperC;

  const handleUserInput = (input) => {
    setUserInput(input);
  };

  const handleNext = useCallback(() => {
    const nextTest = questions[index + 1];
    dispatchAnswer({
      type: "ADD_ANSWER",
      payload: answeredQues(
        "pattern_pair_association",
        userInput,
        question,
        time
      ),
    });
    if (index < questions.length - 1) {
      reset();
      start();
      dispatchHelper({
        type: "RUNNING_QUES_ID",
        payload: nextTest.id,
      });
    } else {
      const answerRes = [...answerC.answers];
      const { player_time, player_score } = totalTimeOrScore(
        answerRes,
        questions,
        false //is reaction test
      );
      const formatValue = {
        grade_id,
        player_id: login_id,
        res: answerRes, // Use the updated answers here
        player_image: "",
        player_time,
        player_score,
        test_id: question.test_id,
      };
      addTestResult(formatValue, dispatchHelper, dispatchAnswer);
      dispatchHelper({
        type: "RUNNING_QUES_ID",
        payload: "submitted",
      });
    }
  }, [
    questions,
    index,
    dispatchAnswer,
    userInput,
    question,
    time,
    reset,
    start,
    dispatchHelper,
    answerC.answers,
  ]);

  useEffect(() => {
    if (isNextQues) {
      handleNext();
      dispatchHelper({ type: "IS_NEXT_QUES", payload: false });
    }
  }, [dispatchHelper, handleNext, isNextQues]);

  useEffect(() => {
    if (!showingNumbers) return;
    if (hasFinished) return;

    const initialDelay = setTimeout(() => {
      setShowingImage(true);
    }, 500);

    const visibilityInterval = setInterval(() => {
      setShowingImage((prev) => !prev);
    }, 2000);

    const imageChangeInterval = setInterval(() => {
      setImageIndex((prevIndex) => {
        const nextIndex = prevIndex + 1;
        if (nextIndex >= picturesArray?.length) {
          clearInterval(visibilityInterval);
          clearInterval(imageChangeInterval);
          setShowingImage(false);
          setHasFinished(true);
          return prevIndex;
        }
        return nextIndex;
      });
    }, 2000);

    return () => {
      clearTimeout(initialDelay);
      clearInterval(visibilityInterval);
      clearInterval(imageChangeInterval);
    };
  }, [imageIndex, hasFinished]);

  useEffect(() => {
    if (hasFinished) {
      dispatchHelper({
        type: "SHOWING_NUMBERS",
        payload: false,
      });
    }
  }, [dispatchHelper, hasFinished]);

  return (
    <div className="rem-flex">
      <div className="test-header rev-question">
        {showingNumbers ? question.que_title1 : question.que_title2}
      </div>
      {showingNumbers ? (
        <div className="rem-question-box">
          {imageIndex > -1 && showingImage && imageIndex !== -1 && (
            <img
              src={require(`../../assets/img/patternPairAssociation/${picturesArray[imageIndex]}.png`)}
              alt=""
            />
          )}
        </div>
      ) : (
        <div className="ppa-images-container">
          <button className={`button-box ${question.imagePosition === 1 ? 'order-2' : 'order-1'} ${userInput === question.correct_text ? 'selected': ''}`.trim()} onClick={() => handleUserInput(question.correct_text)}>
            <img
                src={require(`../../assets/img/patternPairAssociation/${question.correct_text}.png`)}
                alt=""
              />
          </button>
          <button className={`button-box ${question.imagePosition === 1 ? 'order-1' : 'order-2'} ${userInput === picturesArray2[index] ? 'selected': ''}`.trim()} onClick={() => handleUserInput(picturesArray2[index])}>
            <img
                src={require(`../../assets/img/patternPairAssociation/${picturesArray2[index]}.png`)}
                alt=""
              />
          </button>
          
        </div>
      )}
      <TestFooter
        index={index}
        question={question}
        questions={questions}
        isUserInput={userInput}
      />
    </div>
  );
};

export default PatternPairAssociation;

// import React, { Fragment, useEffect, useReducer, useRef } from "react";
// import Countdown from "react-countdown";
// import FullScreenLoader from "../../components/fullScreenLoader/fullScreenLoader";
// import { HelperContext } from "../../store/helperStore";
// import "./patternPairAssociation.scss";

// const picturesArray = [
//   "q1_option1_1",
//   "q1_option2_1",
//   "q1_option3_1",
//   "q1_option4_1",
//   "q1_option5_1",
// ];
// const picturesArray2 = [
//   "q1_option1_2",
//   "q1_option2_2",
//   "q1_option3_2",
//   "q1_option4_2",
//   "q1_option5_2",
// ];

// const reducer = (state, action) => {
//   switch (action.type) {
//     case "ID":
//       return { ...state, id: action.payload };
//     case "STEP":
//       return { ...state, step: action.payload };
//     case "IS_MSG":
//       return { ...state, isMsg: action.payload };
//     case "COUNTDOWN":
//       return { ...state, isStartCountDown: action.payload };
//     default:
//       return state;
//   }
// };

// export default function PatternPairAssociation({ question }) {
//   const initialState = {
//     id: 0,
//     step: 1,
//     isMsg: true,
//     isStartCountDown: false,
//   };

//   const { helperC, dispatchHelper } = HelperContext();
//   const autoImageSlider = useRef();
//   const instrTimeout = useRef();

//   // const { picturesArray, picturesArray2 } = question;

//   const [PPAState, dispatchPPA] = useReducer(reducer, initialState);

//   const { id, step, isMsg, isStartCountDown } = PPAState;

//   const handleNextImage = (index) => {
//     if (index < picturesArray.length - 1) {
//       dispatchPPA({ type: "ID", payload: index + 1 });
//     } else {
//       dispatchPPA({ type: "STEP", payload: 2 });
//     }
//   };

//   const handleImageSlider = (index) => {
//     autoImageSlider.current = setTimeout(() => {
//       clearTimeout(autoImageSlider.current);
//       handleNextImage(index);
//     }, 2000); // 1500ms display time + 500ms hide time
//   };

//   const handleTest = () => {
//     return (
//       <div className="test-body">
//         <p className="ppa-instruction">Select the pattern that matches:</p>
//         <div className="pattern-test">
//           <img
//             alt=""
//             src={require(`../../assets/img/patternPairAssociation/${picturesArray[id]}.png`)}
//           />
//           <div className="options">
//             {picturesArray2.map((pattern, index) => (
//               <img
//                 key={index}
//                 alt=""
//                 src={require(`../../assets/img/patternPairAssociation/${pattern}.png`)}
//                 onClick={() => handlePatternSelection(pattern)}
//               />
//             ))}
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const handlePatternSelection = (selectedPattern) => {
//     // Logic for handling pattern selection
//     console.log("Selected pattern:", selectedPattern);
//     if (id < picturesArray.length - 1) {
//       dispatchPPA({ type: "ID", payload: id + 1 });
//     } else {
//       dispatchPPA({ type: "STEP", payload: 3 }); // End of test
//     }
//   };

//   useEffect(() => {
//     if (step === 1) {
//       instrTimeout.current = setTimeout(() => {
//         clearTimeout(instrTimeout.current);
//         dispatchPPA({ type: "IS_MSG", payload: false });
//       }, 3000);
//     } else if (step === 2) {
//       instrTimeout.current = setTimeout(() => {
//         clearTimeout(instrTimeout.current);
//         dispatchPPA({ type: "COUNTDOWN", payload: true });
//       }, 500); // Initial delay before showing countdown
//     }
//   }, [step]);

//   useEffect(() => {
//     if (step === 1 && !isMsg) {
//       handleImageSlider(id);
//     }
//   }, [id, isMsg, step]);

//   return (
//     <>
//       {isMsg && step === 1 ? (
//         <FullScreenLoader msg={`You have to remember the patterns.`} />
//       ) : step === 1 ? (
//         <div className="pattern-show">
//           <img
//             alt=""
//             src={require(`../../assets/img/patternPairAssociation/${picturesArray[id]}.png`)}
//           />
//         </div>
//       ) : step === 2 ? (
//         <div className="test-instruction-fn">
//           <div className="test-instruction-blk">
//             <MyCountdown
//               timer={3}
//               handleCountdown={() => {
//                 dispatchPPA({ type: "COUNTDOWN", payload: false });
//                 dispatchPPA({ type: "STEP", payload: 3 });
//               }}
//             />
//           </div>
//         </div>
//       ) : step === 3 ? (
//         handleTest()
//       ) : null}
//     </>
//   );
// }

// const MyCountdown = React.memo(function MyCountdown({ timer, handleCountdown }) {
//   return (
//     <Countdown
//       date={Date.now() + timer * 1000}
//       onComplete={() => handleCountdown()}
//       renderer={({ seconds }) => {
//         return <span className="timer">{seconds}</span>;
//       }}
//     />
//   );
// });
